import React from 'react';
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js';

const ApplePayButton = ({ paymentRequest, showDivider = true }) => {
  return (
    <>
      <div className="rounded-xs border-[0.78px] p-2 border-dark-500/20 mt-5">
        <PaymentRequestButtonElement
          options={{
            paymentRequest: paymentRequest,
            style: {
              paymentRequestButton: {
                type: 'default',
                theme: 'dark',
                height: '48px',
              },
            },
          }}
        />
      </div>
      {showDivider && (
        <p className="font-inter font-light text-base leading-[18px] text-center mt-4 text-dark-100">
          OR
        </p>
      )}
    </>
  );
};

export default ApplePayButton;